
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import { BASE_URL } from '../../../config/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { formattedDateLong } from '../../Date';
import { formatCurrencyIndian, handleErrorToast } from '../../CustomFunctions';
import usePermission from '../../../config/permissions';
import pe from '../../../config/permissions';
import { Modal } from 'react-bootstrap';
import { AddDocuments, DocumentModel } from '../ProjectDetailsCrudButtons';
import { DeleteDustbin, Eye } from '../../AllSvg';
import Select from "react-select";
import { EmployeeSalaryStructure, PayrollSalaryStructureFormat } from '../../PayrollManagement/PayrollComponents';

// Not in Use
const AddSalaryDetails = ({
    code,
    salaryData,
    getSalaryData,
}) => {

    console.log("code")
    console.log(code)


    const [show, setShow] = useState(false);


    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setFormData(salaryData.emp_code ? salaryData : {
            emp_code: code,
            basicsalary: "",
            hra: "",
            transport: "",
            specialallowance: "",
            bonus: "",
        });

    };

    const [formData, setFormData] = useState({
        emp_code: code,
        basicsalary: "",
        hra: "",
        transport: "",
        specialallowance: "",
        bonus: "",
    });
    // console.log("formData")
    // console.log(formData.emp_code)
    // console.log("salaryData")
    // console.log(salaryData.emp_code ? "sa" : "as")
    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "basicsalary",
            "hra",
            "transport",
            "specialallowance",
            "bonus",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    useEffect(() => { }, [formData]);
    const [loading, setLoading] = useState(false); //loading logic
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(`${BASE_URL}/siteproject/salarydataadd/`, formData);

                if (res.status === 200) {
                    await getSalaryData(code);
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/salarystructureupdateandget/${code}/`,
                    formData
                );

                if (res.status === 200) {
                    await getSalaryData(code);
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                className="model-view-button model-add"
                title="Add Salary Details"
                onClick={handleShow}
            >
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 500 496" fill="none">
              <path d="M496.406 156.637C494.111 154.783 477.489 143.796 468.822 137.923V118.433C468.822 103.176 456.406 90.76 441.153 90.76H398.622L277.339 9.28002C260.728 -1.88598 239.271 -1.88598 222.66 9.28002L101.379 90.761H58.8466C43.5936 90.761 31.1776 103.177 31.1776 118.434V137.923L4.06058 156.141C2.34758 157.287 0.517578 160.417 0.517578 162.682V460.304C0.517578 479.488 16.1236 495.094 35.3036 495.094H464.696C483.876 495.094 499.482 479.488 499.482 460.304V162.683C499.482 160.834 498.514 158.3 496.406 156.637ZM483.776 460.305C483.776 462.885 483.249 465.341 482.317 467.588L332.225 324.952L483.776 180.893V460.305ZM17.6826 467.589C16.7506 465.342 16.2236 462.886 16.2236 460.306V180.892L167.775 324.951L17.6826 467.589ZM91.7536 211.851C91.7536 203.181 98.7556 196.13 107.36 196.13C116.026 196.13 123.081 203.181 123.081 211.851C123.081 220.455 116.026 227.453 107.36 227.453C98.7556 227.453 91.7536 220.456 91.7536 211.851ZM392.525 227.453C383.921 227.453 376.919 220.455 376.919 211.851C376.919 203.181 383.921 196.13 392.525 196.13C401.191 196.13 408.246 203.181 408.246 211.851C408.246 220.456 401.19 227.453 392.525 227.453ZM479.044 163.718L468.821 173.435V156.85L479.044 163.718ZM231.418 22.317C242.706 14.725 257.293 14.725 268.581 22.317L370.454 90.761H129.546L231.418 22.317ZM58.8466 106.466H441.152C447.747 106.466 453.115 111.834 453.115 118.433V188.364L423.475 216.539C423.71 214.998 423.951 213.456 423.951 211.85C423.951 194.522 409.856 180.423 392.524 180.423C375.262 180.423 361.212 194.522 361.212 211.85C361.212 229.112 375.261 243.158 392.524 243.158C393.652 243.158 394.72 242.942 395.818 242.826L317.692 317.07H182.307L104.193 242.838C105.249 242.946 106.276 243.158 107.36 243.158C124.692 243.158 138.787 229.113 138.787 211.85C138.787 194.522 124.692 180.423 107.36 180.423C90.0976 180.423 76.0476 194.522 76.0476 211.85C76.0476 213.455 76.2876 214.997 76.5216 216.537L46.8836 188.363V118.432C46.8836 111.835 52.2516 106.466 58.8466 106.466ZM31.1776 156.85V173.435L20.9546 163.718L31.1776 156.85ZM35.3036 479.389C33.1606 479.389 31.1336 478.954 29.2086 478.299L182.307 332.807H317.693L470.791 478.299C468.866 478.954 466.84 479.389 464.696 479.389H35.3036Z" fill="black" />
            </svg> */}
                <svg
                    width="20"
                    height="21"
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 512 512"
                    viewBox="0 0 512 512"
                    id="salary"
                >
                    <path
                        d="M256.092,304.837c37.984,0,68.881-38.148,68.881-85.043c0-0.196-0.023-0.384-0.024-0.579
                  c0.001-0.195,0.024-0.383,0.024-0.579c0-46.895-30.898-85.043-68.881-85.043c-38.083,0-69.065,38.148-69.065,85.043
                  c0,0.196,0.023,0.384,0.024,0.579c-0.001,0.195-0.024,0.383-0.024,0.579C187.027,266.688,218.009,304.837,256.092,304.837z
                   M256.092,150.456c29.168,0,52.911,30.794,53.153,68.758c-0.242,37.964-23.985,68.758-53.153,68.758
                  c-29.275,0-53.094-30.794-53.337-68.758C202.998,181.25,226.817,150.456,256.092,150.456z"
                    ></path>
                    <path
                        d="M257.288,242.152h-17.677c-4.341,0-7.853,3.516-7.853,7.853c0,4.337,3.512,7.853,7.853,7.853h8.558v2.719
                  c0,4.337,3.512,7.853,7.853,7.853s7.853-3.516,7.853-7.853v-3.798c9.431-2.853,16.365-11.526,16.365-21.881
                  c0-12.657-10.299-22.957-22.953-22.957c-0.787,0-3.363,0-2.577,0c-3.995,0-7.247-3.255-7.247-7.255
                  c0-3.999,3.252-7.251,7.247-7.251h17.677c4.341,0,7.853-3.516,7.853-7.853c0-4.337-3.512-7.853-7.853-7.853h-8.512v-2.719
                  c0-4.337-3.512-7.853-7.853-7.853s-7.853,3.516-7.853,7.853v3.784c-9.456,2.838-16.411,11.522-16.411,21.891
                  c0,12.661,10.299,22.96,22.953,22.96h2.577c3.995,0,7.247,3.252,7.247,7.251S261.284,242.152,257.288,242.152z"
                    ></path>
                    <path
                        d="M502.406,164.637c-2.295-1.854-18.917-12.841-27.584-18.714v-19.49c0-15.257-12.416-27.673-27.669-27.673h-42.531
                  L283.339,17.28c-16.611-11.166-38.068-11.166-54.679,0L107.379,98.761H64.847c-15.253,0-27.669,12.416-27.669,27.673v19.489
                  l-27.117,18.218c-1.713,1.146-3.543,4.276-3.543,6.541v297.622c0,19.184,15.606,34.79,34.786,34.79h429.392
                  c19.18,0,34.786-15.606,34.786-34.79V170.683C505.482,168.834,504.514,166.3,502.406,164.637z M489.776,468.305
                  c0,2.58-0.527,5.036-1.459,7.283L338.225,332.952l151.551-144.059V468.305z M23.683,475.589
                  c-0.932-2.247-1.459-4.703-1.459-7.283V188.892l151.551,144.059L23.683,475.589z M97.754,219.851
                  c0-8.67,7.002-15.721,15.606-15.721c8.666,0,15.721,7.051,15.721,15.721c0,8.604-7.055,15.602-15.721,15.602
                  C104.756,235.453,97.754,228.456,97.754,219.851z M398.525,235.453c-8.604,0-15.606-6.998-15.606-15.602
                  c0-8.67,7.002-15.721,15.606-15.721c8.666,0,15.721,7.051,15.721,15.721C414.246,228.456,407.19,235.453,398.525,235.453z
                   M485.044,171.718l-10.223,9.717V164.85L485.044,171.718z M237.418,30.317c11.288-7.592,25.875-7.592,37.163,0l101.873,68.444
                  H135.546L237.418,30.317z M64.847,114.466h382.305c6.595,0,11.963,5.368,11.963,11.967v69.931l-29.64,28.175
                  c0.235-1.541,0.476-3.083,0.476-4.689c0-17.328-14.095-31.427-31.427-31.427c-17.262,0-31.312,14.099-31.312,31.427
                  c0,17.262,14.049,31.308,31.312,31.308c1.128,0,2.196-0.216,3.294-0.332l-78.126,74.244H188.307l-78.114-74.232
                  c1.056,0.108,2.083,0.32,3.167,0.32c17.332,0,31.427-14.045,31.427-31.308c0-17.328-14.095-31.427-31.427-31.427
                  c-17.262,0-31.312,14.099-31.312,31.427c0,1.605,0.24,3.147,0.474,4.687l-29.638-28.174v-69.931
                  C52.884,119.835,58.252,114.466,64.847,114.466z M37.178,164.85v16.585l-10.223-9.717L37.178,164.85z M41.304,487.389
                  c-2.143,0-4.17-0.435-6.095-1.09l153.098-145.492h135.386l153.098,145.492c-1.925,0.655-3.951,1.09-6.095,1.09H41.304z"
                    ></path>
                </svg>
            </button>

            <Modal
                show={show}
                onHide={loading ? null : handleClose}
                dialogClassName="request-leave width-40vw"
            >
                {/* <Modal.Header closeButton>
            <Modal.Title>Request Leave</Modal.Title>
          </Modal.Header> */}
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Finance Details</h6>

                            {/* <div className="flex-column">
                  <label htmlFor="date" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                    Date<span className="required">*</span>
                  </label>
                  <input
                    id="date"
                    type="date"
                    name='date'
                    onChange={handleInputChange}
                    value={formData.date}
                    className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
                      }`}
                  />
                  {errors.date && (
                    <span className="error-message font-size-text ">{errors.date}</span>
                  )}
                </div> */}

                            <div className="flex-column">
                                <label htmlFor="emp_code" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Employee Code<span className="required">(Read-Only)</span>
                                </label>
                                <input
                                    id="emp_code"
                                    type="text"
                                    name="emp_code"
                                    placeholder={formData.emp_code}
                                    onChange={handleInputChange}
                                    readOnly
                                    value={formData.emp_code}
                                    className={`form-input ${errors.emp_code
                                        ? "error"
                                        : inputState.emp_code
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.emp_code && (
                                    <span className="error-message font-size-text ">{errors.emp_code}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="basicsalary"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Basic Salary
                                </label>
                                <input
                                    id="basicsalary"
                                    name="basicsalary"
                                    type="number"
                                    onChange={handleInputChange}
                                    // placeholder="00000"
                                    value={formData.basicsalary}
                                    className={`form-input ${errors.basicsalary
                                        ? "error"
                                        : inputState.basicsalary
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.basicsalary && (
                                    <span className="error-message font-size-text ">{errors.basicsalary}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="hra" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    HRA
                                </label>
                                <input
                                    id="hra"
                                    type="number"
                                    name="hra"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.hra}
                                    className={`form-input ${errors.hra ? "error" : inputState.hra ? "success" : ""
                                        }`}
                                />
                                {errors.hra && (
                                    <span className="error-message font-size-text ">{errors.hra}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="transport"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Transportation
                                </label>
                                <input
                                    id="transport"
                                    type="number"
                                    name="transport"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.transport}
                                    className={`form-input ${errors.transport
                                        ? "error"
                                        : inputState.transport
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.transport && (
                                    <span className="error-message font-size-text ">{errors.transport}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="specialallowance"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Special Allowance
                                </label>
                                <input
                                    id="specialallowance"
                                    type="number"
                                    name="specialallowance"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.specialallowance}
                                    className={`form-input ${errors.specialallowance
                                        ? "error"
                                        : inputState.specialallowance
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.specialallowance && (
                                    <span className="error-message font-size-text ">
                                        {errors.specialallowance}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="bonus" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Bonus
                                </label>
                                <input
                                    id="bonus"
                                    type="number"
                                    name="bonus"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.bonus}
                                    className={`form-input ${errors.bonus ? "error" : inputState.bonus ? "success" : ""
                                        }`}
                                />
                                {errors.bonus && (
                                    <span className="error-message font-size-text ">{errors.bonus}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button
                                    className="model-button   font-weight500   "
                                    onClick={handleClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>

                                {salaryData.basicsalary ? (
                                    <button
                                        type="submit"
                                        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                        onClick={handleUpdate}
                                        disabled={loading}
                                    >
                                        Update
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        Add
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const Finance = ({ email, emp_code, sub_company }) => {
    const { PERMISSION_ROLE } = usePermission(); // Use the custom hook


    const [salarylist] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    // const getSalaryList = async () => {
    //     setBuffering(true); // Start Buffering
    //     try {
    //         const res = await axios.get(
    //             `${BASE_URL}/siteproject/salarystructureupdateandget/${emp_code}/`
    //         );
    //         console.log("API Response:", res.data); // Log the response
    //         setSalarylist(res.data);

    //     } catch (err) {
    //         //toast Logic
    //         handleErrorToast(err);
    //     } finally {
    //         setBuffering(false);// End Buffering
    //     }
    // };

    console.log(salarylist);
    // useEffect(() => {
    //     getSalaryList();
    // }, []);

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl = "/" + urlParts[3] + `/salarySlipEmployee`;

    const OneSalarySlip = (i) => {
        navigate(baseUrl, { state: { i } });
    };

    const [salaryData, setSalaryData] = useState({});
    const getSalaryData = async (emp_code) => {
        setBuffering(true); // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/salarystructureupdateandget/${emp_code}/`
            );
            setSalaryData(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    // useEffect(() => {
    //     getSalaryData(emp_code);
    // }, [emp_code]);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />



            {/* Finance Sales List */}
            < div className="table-css-white-background" >
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">Salary Slip List</div>
                    {PERMISSION_ROLE ? (
                        <div>
                            Salary Structure:
                            <PayrollSalaryStructureFormat
                                code={emp_code}
                                sub_company={sub_company}
                                getSalaryStructure={getSalaryData}
                            // getSalaryStructure={getSalaryStructure}
                            />
                            {/* Add Salary Details:{" "}
                            <AddSalaryDetails
                                code={emp_code}
                                salaryData={salaryData}
                                getSalaryData={getSalaryData}
                            /> */}
                        </div>
                    ) : null}
                </div>
                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            {/* <th className='align-left'>Date</th>
                                <th className='align-center'>Basic Pay</th>
                                <th className='align-center'>Salary</th>
                                <th className='align-center'>Deduction</th>
                                <th className='align-center'>Allowance</th>
                                <th className='align-center'>Net Pay</th>
                                <th className='align-right width-5vw'>Salary Receipt</th> */}
                            <th className="align-left">Sr. No.</th>
                            <th className="align-center">Month</th>
                            <th className="align-center">Year</th>
                            <th className="align-center">Total Pay days</th>
                            <th className="align-center">Net Pay</th>
                            <th className="align-right width-5vw">Salary Receipt</th>
                        </tr>
                    </thead>
                    {buffer ? <div className="spinner"></div> :
                        <tbody>
                            <tr className="tr-border-bottom">
                                <td colSpan={6}></td>
                            </tr>
                            {salarylist.map((item, index) => {
                                return (
                                    <>
                                        <tr className="custom-table-head-td">
                                            <td className="align-left">{index + 1}</td>
                                            <td className="align-center">{item.month}</td>
                                            <td className="align-center">{item.year}</td>
                                            <td className="align-center">{item.calculation}</td>
                                            <td className="align-center">{item.salary.salarypay}</td>

                                            <td className="align-right width-5vw">
                                                <button
                                                    className="allproject-dashboard"
                                                    title="View using Navigate"
                                                    onClick={(e) => OneSalarySlip(item)}
                                                >
                                                    <Eye />
                                                </button>
                                                {/* <img src="" alt="Salary Receipt" /> */}
                                            </td>
                                        </tr>
                                        <tr className="tr-border-bottom">
                                            <td colSpan={6}></td>
                                        </tr>
                                    </>
                                );
                            })}
                        </tbody>}
                </table>
            </div >

        </>
    );
};

const SiteUserDetails = () => {
    const [employeeData, setEmployeeData] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    let { emp_code } = useParams();
    const role = sessionStorage.getItem('sitemanagement_role');
    let { id } = useParams();
    const getUserDetails = async () => {
        setBuffering(true); // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/employeebyempcode/${emp_code}/`);
            setEmployeeData(res.data);

        } catch (err) {
            // alert(err.message);

            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };


    useEffect(() => {
        getUserDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [formDataa, setFormDataa] = useState({
        profilepic: null,
    });

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setFormDataa({
            profilepic: file,
        });

    };

    const uploadFile = async (file) => {
        const formDataa = new FormData();

        const symbols = '!@#$%^&*()_-+=';
        const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
        const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const now = new Date();
        const date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
        const time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
        const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
        let randomCode = '';
        for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * allChars.length);
            randomCode += allChars[randomIndex];
        }
        const originalFile = file;
        const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
        const customFile = new File([originalFile], customFileName, { type: originalFile.type });
        formDataa.append('profilepic', customFile);

        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.put(`${BASE_URL}/siteproject/employee/${employeeData.id}/`, formDataa, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (res.status === 200) {
                await getUserDetails();
                window.location.reload();

            } else {
                alert(res);
            }
        } catch (err) {
            toast.dismiss(loadingToastId); // Dismiss loading toast on error
            // Error handling
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }



    };

    const handleLogoClear = () => {
        setFormDataa({
            ...formDataa,
            profilepic: null,
        });

    };

    return (
        <>
            <div className='user_main-outer'>

                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                <div className='user_main'>
                    <div className='user_inner'>
                        <div className='user_inner_style'>


                            {employeeData.profilepic ? (
                                // <img className='user_img' src={`${IMAGE_URL}${employeeData.profilepic}`} alt='user_img' />
                                <img className='user_img' src={`${employeeData.profilepic}`} alt='user_img' />
                            ) : (
                                role !== "ViewAccess" ?

                                    <>
                                        <input
                                            type="file"
                                            name="profilepic"
                                            accept="image/*"
                                            onChange={handleLogoChange}
                                            className="file-input"
                                            style={{ width: '200px' }}
                                        // size="5"
                                        />


                                        {formDataa.profilepic ? (
                                            <>
                                                <span className="file-clearr" style={{ padding: '2px 5px', borderRadius: '10px', color: 'white', backgroundColor: '#2576bc', opacity: '0.6' }} onClick={handleLogoClear}>
                                                    Clear
                                                </span>
                                                <span>/</span>
                                                <span className="file-clear" style={{ padding: '2px 5px', borderRadius: '10px', color: 'white', backgroundColor: '#2576bc', opacity: '0.6' }} onClick={(e) => uploadFile(formDataa.profilepic)}>
                                                    Submit
                                                </span>
                                                <br />
                                                <img
                                                    src={URL.createObjectURL(formDataa.profilepic)}
                                                    alt="Logo Preview"
                                                    className="user_img_trial"
                                                />

                                            </>
                                        ) : (
                                            <>
                                                <br />
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-cloud-upload"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                                                    />
                                                </svg>
                                                <span className="file-name" style={{ marginLeft: "20px" }}>
                                                    Upload Profile Pic
                                                </span>
                                            </>
                                        )}
                                    </> : ""



                            )}
                            <div className={employeeData.profilepic ? "user_img_box" : "user_img_boxx"}>{employeeData.designation_name}</div>
                        </div>


                        <div className='user_del'>
                            <div className='flex-row' style={{ paddingRight: " 5vw", justifyContent: "space-between", flexWrap: 'wrap' }}>
                                <div>
                                    <h1 className='user_name   font-weight500 font-size-heading'>{employeeData?.name}</h1></div>


                            </div>
                            <p className='user_desg  font-weight500  font-size-heading'>{employeeData?.designation_name} at {employeeData?.division_name}</p>
                            <div className='user_inner_del font-weight400  font-size-subheading  width-60vw'>
                                <div className='user_inner_box'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                        <path d="M7 4C6.38193 4 5.77775 4.18328 5.26384 4.52666C4.74994 4.87004 4.3494 5.3581 4.11288 5.92911C3.87635 6.50013 3.81447 7.12847 3.93505 7.73466C4.05562 8.34085 4.35325 8.89767 4.79029 9.33471C5.22733 9.77175 5.78415 10.0694 6.39034 10.19C6.99653 10.3105 7.62487 10.2486 8.19589 10.0121C8.7669 9.7756 9.25496 9.37506 9.59834 8.86116C9.94172 8.34725 10.125 7.74307 10.125 7.125C10.125 6.2962 9.79576 5.50134 9.20971 4.91529C8.62366 4.32924 7.8288 4 7 4ZM7 9C6.62916 9 6.26665 8.89003 5.95831 8.68401C5.64996 8.47798 5.40964 8.18514 5.26773 7.84253C5.12581 7.49992 5.08868 7.12292 5.16103 6.75921C5.23337 6.39549 5.41195 6.0614 5.67417 5.79917C5.9364 5.53695 6.27049 5.35837 6.63421 5.28603C6.99792 5.21368 7.37492 5.25081 7.71753 5.39273C8.06014 5.53464 8.35298 5.77496 8.55901 6.08331C8.76503 6.39165 8.875 6.75416 8.875 7.125C8.875 7.62228 8.67746 8.09919 8.32583 8.45083C7.97419 8.80246 7.49728 9 7 9ZM7 0.25C5.17727 0.252068 3.42979 0.97706 2.14092 2.26592C0.85206 3.55479 0.127068 5.30227 0.125 7.125C0.125 9.57812 1.25859 12.1781 3.40625 14.6445C4.37127 15.759 5.45739 16.7626 6.64453 17.6367C6.74962 17.7103 6.87482 17.7498 7.00312 17.7498C7.13143 17.7498 7.25663 17.7103 7.36172 17.6367C8.54668 16.7623 9.63069 15.7587 10.5938 14.6445C12.7383 12.1781 13.875 9.57812 13.875 7.125C13.8729 5.30227 13.1479 3.55479 11.8591 2.26592C10.5702 0.97706 8.82273 0.252068 7 0.25ZM7 16.3438C5.70859 15.3281 1.375 11.5977 1.375 7.125C1.375 5.63316 1.96763 4.20242 3.02252 3.14752C4.07742 2.09263 5.50816 1.5 7 1.5C8.49184 1.5 9.92258 2.09263 10.9775 3.14752C12.0324 4.20242 12.625 5.63316 12.625 7.125C12.625 11.5961 8.29141 15.3281 7 16.3438Z" fill="#707070" />
                                    </svg>
                                    <p>{employeeData?.sub_company_name}</p>
                                </div>
                                <div className='user_inner_box'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M17.5 3.75H2.5C2.33424 3.75 2.17527 3.81585 2.05806 3.93306C1.94085 4.05027 1.875 4.20924 1.875 4.375V15C1.875 15.3315 2.0067 15.6495 2.24112 15.8839C2.47554 16.1183 2.79348 16.25 3.125 16.25H16.875C17.2065 16.25 17.5245 16.1183 17.7589 15.8839C17.9933 15.6495 18.125 15.3315 18.125 15V4.375C18.125 4.20924 18.0592 4.05027 17.9419 3.93306C17.8247 3.81585 17.6658 3.75 17.5 3.75ZM15.893 5L10 10.4023L4.10703 5H15.893ZM16.875 15H3.125V5.79609L9.57734 11.7109C9.69265 11.8168 9.84348 11.8755 10 11.8755C10.1565 11.8755 10.3074 11.8168 10.4227 11.7109L16.875 5.79609V15Z" fill="#707070" />
                                    </svg>
                                    <a href={`mailto:${employeeData?.email}`}><p style={{ textDecoration: "underline" }}>{employeeData?.email}</p></a>
                                </div>
                                <div className='user_inner_box'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M17.3727 12.3798L13.6922 10.7306L13.682 10.7259C13.491 10.6441 13.2825 10.6114 13.0756 10.6304C12.8687 10.6495 12.6698 10.7199 12.4969 10.8352C12.4765 10.8487 12.457 10.8633 12.4383 10.879L10.5367 12.5001C9.33204 11.9149 8.08829 10.6806 7.50313 9.49149L9.12657 7.56102C9.14219 7.54149 9.15704 7.52196 9.1711 7.50087C9.28394 7.32845 9.35239 7.13081 9.37039 6.92553C9.38838 6.72026 9.35534 6.51372 9.27423 6.3243V6.31493L7.62032 2.62821C7.51309 2.38076 7.3287 2.17463 7.09468 2.04058C6.86067 1.90654 6.58958 1.85177 6.32188 1.88446C5.26326 2.02376 4.29155 2.54366 3.58824 3.34704C2.88492 4.15042 2.49809 5.18234 2.50001 6.25009C2.50001 12.4532 7.54688 17.5001 13.75 17.5001C14.8177 17.502 15.8497 17.1152 16.6531 16.4119C17.4564 15.7085 17.9763 14.7368 18.1156 13.6782C18.1484 13.4106 18.0937 13.1396 17.9598 12.9056C17.8259 12.6716 17.62 12.4871 17.3727 12.3798ZM13.75 16.2501C11.0987 16.2472 8.55687 15.1927 6.68214 13.318C4.8074 11.4432 3.7529 8.90136 3.75001 6.25009C3.74707 5.48719 4.02192 4.7493 4.52324 4.17423C5.02456 3.59916 5.71806 3.22623 6.47423 3.12509C6.47392 3.1282 6.47392 3.13134 6.47423 3.13446L8.11485 6.80634L6.50001 8.73915C6.48362 8.75801 6.46873 8.77812 6.45548 8.7993C6.33791 8.97971 6.26894 9.18743 6.25525 9.40232C6.24157 9.61722 6.28362 9.83201 6.37735 10.0259C7.08516 11.4735 8.54376 12.9212 10.007 13.6282C10.2023 13.7211 10.4184 13.7617 10.634 13.7461C10.8497 13.7304 11.0576 13.6592 11.2375 13.5391C11.2576 13.5256 11.2769 13.511 11.2953 13.4954L13.1945 11.8751L16.8664 13.5196C16.8664 13.5196 16.8727 13.5196 16.875 13.5196C16.7751 14.2769 16.4027 14.9718 15.8275 15.4743C15.2524 15.9769 14.5138 16.2527 13.75 16.2501Z" fill="#707070" />
                                    </svg>
                                    <a href={`tel:+91${employeeData?.mobile}`}><p style={{ textDecoration: "underline" }}>{employeeData?.mobile}</p></a>

                                </div>
                                <DocumentModel employee={employeeData.id} getDocument={getUserDetails} employeeData={employeeData} title={"Employee Document"} />
                            </div>
                        </div>




                    </div>
                    <div className='user_inner2 font-weight400 '>
                        <div>
                            <h1 className='font-size-text'>Job Title</h1>
                            <p>{employeeData?.designation_name}</p>
                        </div>
                        <div>
                            <h1 className='font-size-text'>Employee Staus</h1>
                            <p>{employeeData.employee_status}</p>
                        </div>
                        <div>
                            <h1 className='font-size-text'>Business Unit</h1>
                            <p>{employeeData?.sub_company_name}</p>
                        </div>
                        <div>
                            <h1 className='font-size-text'>Date of Birth</h1>
                            <p>{formattedDateLong(employeeData.dob)}
                            </p>
                        </div>
                        <div>
                            <h1 className='font-size-text'>Emp no</h1>
                            <p>{employeeData?.emp_code}</p>
                        </div>
                    </div>

                </div>

            </div >

            <div className="main-div-personaldetial content-tabss" style={{ marginTop: "10px" }}>
                <div className="presonal-info">


                    <div className="personal-detail width-25vw">
                        <h3 className="personal-detail-heading   font-weight500  font-size-heading">Personal Details</h3>
                        {buffer ? <div className="spinner-smalll"></div> :
                            <table>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Gender</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.gender}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Mobile Number</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.mobile}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Email</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.email}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Marital Status</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.married_status}</th>
                                </tr>

                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Emergency Contact</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">
                                        {employeeData.emergency_person_name} : {employeeData.emergency_phone_number} ({employeeData.emergency_relation})
                                    </th>
                                </tr>
                            </table>
                        }
                    </div>

                    <div className="contact-details width-25vw">
                        <h3 className="personal-detail-heading   font-weight500  font-size-heading">Bank Details</h3>

                        {buffer ? <div className="spinner-smalll"></div> :
                            <table>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Bank Name</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.bank_name}
                                    </th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">IFSC Code</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.ifsc_code}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Account Number</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.account_number}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Account Number</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.account_number}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">PAN Number</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.pan}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Aadhaar Number</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.aadhaar}</th>
                                </tr>
                            </table>
                        }
                    </div>

                </div >

            </div >

            <div className="main-div-personaldetial content-tabss" style={{ marginTop: "10px" }}>
                <div className="presonal-info">


                    <div className="personal-detail width-25vw">
                        {/* <h3 className="personal-detail-heading   font-weight500  font-size-heading">Personal Details</h3> */}
                        {buffer ? <div className="spinner-smalll"></div> :
                            <table>
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Project</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.project}</th>
                                </tr> */}
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Joining Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{formattedDateLong(employeeData.joining_date)}</th>
                                </tr>
                                {
                                    employeeData.last_working_date &&
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Last Working Date</td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">{formattedDateLong(employeeData.last_working_date)}</th>
                                    </tr>
                                }
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Professional Type</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.professional_type}</th>
                                </tr>

                            </table>
                        }
                    </div>

                    <div className="contact-details width-25vw">
                        {/* <h3 className="personal-detail-heading   font-weight500  font-size-heading">Bank Details</h3> */}

                        {buffer ? <div className="spinner-smalll"></div> :
                            <table>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Employee Status</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.employee_status}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Qualification</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.qualification}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">UAN</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.uan}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Current Address</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.current_address}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text">Emergency Address</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text">{employeeData.emergency_address}</th>
                                </tr>
                            </table>
                        }
                    </div>

                </div >

            </div >
            {role === "SiteManagement" ? <></> :
                <div className='content-tabss'>

                    <Finance emp_code={emp_code} sub_company={employeeData.sub_company} />
                </div>
            }
            {/* <div className='content-tabss' style={{ marginTop: "10px" }}>
                <Finance emp_code={emp_code} />
            </div> */}
        </>
    )
}

export default SiteUserDetails;
